import React from 'react';
import { Container, Typography, Box, Button, Stack, Avatar } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { env, fetchGithub, fetchProjects } from '../services/AppService';
import Grid from '@mui/material/Grid2';
import { projectData } from '../data';
import Link from '@mui/material/Link';
import './ProjectPage.css';

const ProjectList = () => {
	const [projects, setProjects] = React.useState([]);
	React.useEffect(() => {
		fetchProjects()
			.then(response => {
				setProjects(response.data.results || response.data);
			})
			.catch(error => console.error('Error fetching projects:', error));
	}, []);

	if (!projects || projects.length === 0) {
		return <Typography>No projects available</Typography>;
	}

	return (
		<Stack spacing={5}>
			{projects.map(e => (
				<Grid container key={e.id} direction='row' size={2}>
					<Grid size={4}>
						<Link
							href={e.url || 'www.tdbax.com'}
							sx={{
								fontSize: '1.05rem'
							}}
						>
							<code>{e.name || 'No project name'}</code>
						</Link>
						<Typography sx={{
							fontSize: '1.05rem'
						}}>
							{e.date || new Date().getFullYear()}
						</Typography>
					</Grid>
					<Grid size='grow' alignItems='stretch'>
						<div
							className='project-desc'
							dangerouslySetInnerHTML={{ __html: e.clean_desc || 'No project description' }}
						/>
					</Grid>
				</Grid>
			))}
		</Stack>
	);
};


export default function ProjectPage(props)
{
	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Header />
		<Container
			maxWidth='lg'
			component='main'
			sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
		>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4}}>
      		<div>
      		  <Typography variant="h1" gutterBottom>
      		    tdbax projects
      		  </Typography>
      		  <Typography>Some are notable, many are experiments. </Typography>
      		</div>

			<Typography variant='h2' gutterBottom>
			Projects
			</Typography>

			<ProjectList />

			{/*<Grid container spacing={2}>
				<Grid size={3}>
					<Typography>
						project
					</Typography>
				</Grid>
				<Grid size='grow'>
					<Typography>
						desc
					</Typography>
				</Grid>
			</Grid>*/}



		</Box>

		</Container>
		<Footer />
		</AppTheme>
		</>
	);
}
